import apiFetch from '../apiFetch'

export default function (idDilucion, token) {
  return apiFetch({endPoint: `Dilucion/getDilucion?idDilucion=` + idDilucion, method: 'GET', body: null, token: token})
}
